import styled from 'styled-components'

export const Section = styled.section`
  padding: clamp(48px, 7vw, 90px) 0;
  background: #fff;
`

export const Heading = styled.h2`
  max-width: 900px;
  margin: 0 auto clamp(24px, 4vw, 44px);
  font-size: clamp(26px, 4vw, 44px);
  line-height: 1.15;
  font-weight: 700;
  color: #002107;
  text-align: center;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  max-width: 1200px;
  margin: 0 auto;

  /* Tablet: 2 por linha (3 linhas de 2) */
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
  }

  /* Mobile: um embaixo do outro, largura total para o texto ficar legível */
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    max-width: 520px;
    gap: 18px;
  }
`

export const Card = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  border: 1px solid #e3e8e4;
  border-top: 4px solid #00a70a;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  cursor: zoom-in;
  box-shadow: 0 8px 24px rgba(0, 29, 7, 0.12);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:focus-visible {
    outline: 3px solid #1E8BB8;
    outline-offset: 3px;
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 14px 32px rgba(0, 29, 7, 0.18);
    }
  }
`

export const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

export const Hint = styled.p`
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #5b6b5f;
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 29, 7, 0.85);
  cursor: zoom-out;
`

export const OverlayImg = styled.img`
  width: 100%;
  max-width: 760px;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
  cursor: default;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: #002107;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
`
